<template>
  <div id="app__loading__container">
    <div></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ resource?: string }>();
</script>

<style scoped></style>
